<div class="breadcrumb">
  <div class="container">
    <a routerLink="/">Home</a> > Grupo e Usuarios
  </div>
</div>

<main class="container">
  <p>&nbsp;</p>
  <h1 i18n>Relacionamento de Grupos com usuários</h1>
  <p>&nbsp;</p>

  <h2 i18n>Associar usuário a um grupo:</h2>
  <div class="flex form">
    <div class="form-group">
      <label for="grupo" i18n>Grupos:</label>
      <select class="form-control" id="grupo" [(ngModel)]="grupoSelecionado">
        <option value="" disabled selected i18n>Selecione um grupo</option>
        <option *ngFor="let grupo of groupList" [value]="grupo.id">{{grupo.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <div class="form-group">
        <label for="usuario" i18n>Usuário:</label>
        <select class="form-control" id="usuario" [(ngModel)]="usuarioSelecionado">
          <option value="" disabled selected i18n>Selecione um usuário</option>
          <option *ngFor="let usuario of groupUser" [value]="usuario.id">{{usuario.email}}</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <button class="btn btn-primary" (click)="adicionarUsuarioAoGrupo()" i18n>Associar</button>
    </div>
  </div>

  <h2 i18n>Remover usuário a um grupo:</h2>
  <div class="flex form">
    <div class="form-group">
      <label for="grupo" i18n>Grupos:</label>
      <select class="form-control" id="grupo" [(ngModel)]="grupoSelecionado">
        <option value="" disabled selected i18n>Selecione um grupo</option>
        <option *ngFor="let grupo of groupList" [value]="grupo.id">{{grupo.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <div class="form-group">
        <label for="usuario" i18n>Usuário:</label>
        <select class="form-control" id="usuario" [(ngModel)]="usuarioSelecionado">
          <option value="" disabled selected i18n>Selecione um usuário</option>
          <option *ngFor="let usuario of groupUser" [value]="usuario.id">{{usuario.email}}</option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <button class="btn btn-primary" (click)="removerUsuarioAoGrupo()" i18n>Remover</button>
    </div>
  </div>
  
  <h2 i18n>Criar um grupo:</h2>
  <div class="flex form">
    <div class="form-group">
      <label for="grupo" i18n>Nome:</label>
      <input type="text" class="form-control" id="grupo" [(ngModel)]="groupName">
    </div>
    <div class="form-group">
      <div class="form-group">
        <label for="grupo" i18n>Peso:</label>
        <input type="text" class="form-control" id="grupo" [(ngModel)]="groupPeso">
      </div>
    </div>
    <label for="usuario" i18n>Região:</label>
    <select class="form-control" id="usuario" [(ngModel)]="regiaoSelecionada">
      <option value="" disabled selected i18n>Selecione uma região</option>
      <option *ngFor="let regiao of listaRegiao" [value]="regiao.id">{{regiao.name}}</option>
    </select>
    <div class="form-group">
      <button class="btn btn-primary" (click)="adicionarGrupo()" i18n>Adicionar</button>
    </div>
  </div>

  <h2 i18n>Visualizar grupos e usuários</h2>
  <p i18n>Clique no grupo para espandir</p>
  <cdk-accordion class="example-accordion">
    @for (item of groupList; track item; let index = $index) {
    <cdk-accordion-item #accordionItem="cdkAccordionItem" class="example-accordion-item">
      <div>
        <button
          class="example-accordion-item-header"
          (click)="accordionItem.toggle()"
          tabindex="0"
          [attr.id]="'accordion-header-' + index"
          [attr.aria-expanded]="accordionItem.expanded"
          [attr.aria-controls]="'accordion-body-' + index">
          <span class="example-accordion-item-description">
            {{item.name}}
          </span>
        </button>
      </div>
      @if(accordionItem.expanded) {
      <div
        class="example-accordion-item-body"
        role="region"
        [style.display]="accordionItem.expanded ? '' : 'none'"
        [attr.id]="'accordion-body-' + index"
        [attr.aria-labelledby]="'accordion-header-' + index"
      >
        <div class="historico_item" *ngFor="let item1 of this.historico[index] | keyvalue">
          grupo.name: {{item1.key}} - {{item1.value}}
        </div>
      </div>
      }
    </cdk-accordion-item>
    }
  </cdk-accordion>
</main>